import { useState } from 'react';

import QuarterSelectModal from '../components/QuarterSelectModal';

const QuarterSelectModalContainer = ({
    showPeriodSelectModal, setShowPeriodSelectModal, selectedCrossReport, periodData,
    onCrossReportQuarterSelection,
}) => {
    const [quarter, setQuater] = useState([]);

    const onSaveQuarter = () => {
        const quarters = [];
        for (let i = 0; i < quarter.length; i += 1) {
            const periodDetail = periodData.filter(p => p.period === quarter[i])[0];
            quarters.push(periodDetail);
        }
        const crossReportInput = {
            ...selectedCrossReport,
            quarters,
        };
        onCrossReportQuarterSelection(crossReportInput);
        setShowPeriodSelectModal(false);
    };

    const onCancel = () => {
        setShowPeriodSelectModal(false);
    };

    return (
        <QuarterSelectModal
            showPeriodSelectModal={showPeriodSelectModal}
            setQuarter={setQuater}
            quarter={quarter}
            periodData={periodData}
            selectedCrossReport={selectedCrossReport}
            onCancel={onCancel}
            onSaveQuarter={onSaveQuarter}
        />
    );
};

export default QuarterSelectModalContainer;
